import React, {useEffect, useState} from "react";
import SlideData, {UploadStatus} from "../../../Interfaces/SlideData";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {SWAL_DEFAULTS} from "../../../Utils/defaults";
import AddSlidePopup from "./AddSlidePopup";
import {observer} from "mobx-react-lite";
import SlidesListItem from "./SlidesListItem";
import {ReactSortable} from "react-sortablejs";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {
    addSlide,
    removeAllSlides,
    removeSlide,
    setCurrentSlide,
    setIsAddSlidePopupOpen, setOnBoardingShowReorderPopup, setOnBoardingStep,
    setSlides
} from "../../../store/makerDataSlice";
import {Provider} from "react-redux";
import {store} from "../../../store/store";
import {ErrorBoundary} from "../../Common/ErrorBoundary";
import rotatePhoto from "../../../Api/rotatePhoto";
import {ImageListType} from "react-images-uploading/dist/typings";
import {ImageType} from "../../../ComponentsForked/react-images-uploading/src";
import * as Sentry from "@sentry/react";
import {useMutation} from "@tanstack/react-query";
import uploadPhoto from "../../../Api/uploadPhoto";
import {v4 as uuidv4} from "uuid";
import ym from "react-yandex-metrika";
import axios from "axios";
import addText from "../../../Api/addText";
import {Button} from "react-bootstrap";
import EditSlidePopup from "./EditSlidePopup";
import {OnBoardingStep} from "../../../Interfaces/OnBoardingStep";

interface SlidesListProps {
}

const SlidesList: React.FC<SlidesListProps> = observer(({}) => {

    const slides = useAppSelector(state => state.makerData.slides)
    const tmpProjectId = useAppSelector(state => state.makerData.tmpProjectId)
    const dispatch = useAppDispatch()
    const makerData = useAppSelector(state => state.makerData)
    // makerData.onBoardingShowReorderPopup не обновляется если загружаем за раз несколько фотографий,
    // поэтому, чтобы не показывать popup для каждой фото при загрузке нескольких фото - используем ещё
    // и локальную переменную localOnBoardingShowReorderPopup
    const [localOnBoardingShowReorderPopup, setLocalOnBoardingShowReorderPopup] = useState<boolean>(true);

    const mutationUploadPhoto = useMutation({
        mutationFn: uploadPhoto,
        onError: (error, variables, context) => {
            dispatch(addSlide({
                pid: variables.pid,
                localFileName: variables.image['file']?.name,
                type: 'photo',
                status: UploadStatus.uploadError,
                uploadError: 'Ошибка при загрузке файла'
            } as SlideData));
            let errorUrl = '';
            if (axios.isAxiosError(error)) {
                errorUrl = String(error.config?.url);
                // @ts-ignore
            } else if (typeof error?.url !== 'undefined') {
                // @ts-ignore
                errorUrl = error?.url;
            }
            Sentry.captureException(
                // @ts-ignore
                new Error((error?.message ? error.message : 'Failed to upload photo. Generic error.') + ', URL: ' + errorUrl),
                {
                    extra: {
                        variables: variables,
                        error: error,
                        responseConfig: axios.isAxiosError(error) ? JSON.stringify(error.response?.config) : '',
                        responseData: axios.isAxiosError(error) ? JSON.stringify(error.response?.data) : ''
                    }
                }
            )
            ym('reachGoal', 'addPhotoSlideFail');
        },
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
    })

    const mutationRotatePhoto = useMutation({
        mutationFn: rotatePhoto,
        onError: (error, variables, context) => {
            let errorUrl = '';
            if (axios.isAxiosError(error)) {
                errorUrl = String(error.config?.url);
                // @ts-ignore
            } else if (typeof error?.url !== 'undefined') {
                // @ts-ignore
                errorUrl = error?.url;
            }
            Sentry.captureException(
                // @ts-ignore
                new Error((error?.message ? error.message : 'Failed to rotate photo. Generic error.') + ', URL: ' + errorUrl),
                {
                    extra: {
                        variables: variables,
                        error: error,
                        responseConfig: axios.isAxiosError(error) ? JSON.stringify(error.response?.config) : '',
                        responseData: axios.isAxiosError(error) ? JSON.stringify(error.response?.data) : ''
                    }
                }
            )
        },
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
    })

    const mutationAddText = useMutation({
        mutationFn: addText,
        onError: (error, variables, context) => {
            dispatch(addSlide({
                pid: variables.pid,
                localFileName: '',
                type: 'text',
                status: UploadStatus.uploadError,
                uploadError: 'Ошибка при добавлении текста'
            } as SlideData));
            let errorUrl = '';
            if (axios.isAxiosError(error)) {
                errorUrl = String(error.config?.url);
                // @ts-ignore
            } else if (typeof error?.url !== 'undefined') {
                // @ts-ignore
                errorUrl = error?.url;
            }
            Sentry.captureException(
                // @ts-ignore
                new Error((error?.message ? error.message : 'Failed to add text. Generic error.') + ', URL: ' + errorUrl),
                {
                    extra: {
                        variables: variables,
                        error: error,
                        responseConfig: axios.isAxiosError(error) ? JSON.stringify(error.response?.config) : '',
                        responseData: axios.isAxiosError(error) ? JSON.stringify(error.response?.data) : ''
                    }
                }
            )
            ym('reachGoal', 'addTextSlideFail');
        },
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
    })

    useEffect(() => {
        if (typeof makerData.onBoardingShowReorderPopup === 'undefined' ||
            !makerData.onBoardingShowReorderPopup ||
            !localOnBoardingShowReorderPopup ||
            makerData.slides.length <= 1
        ) {
            return;
        }
        let hasSlidesCreatedByUser = false;
        makerData.slides.map((slide) => {
            if (slide.createdByUser) {
                hasSlidesCreatedByUser = true;
            }
        });
        if (!hasSlidesCreatedByUser) {
            return;
        }

        dispatch(setOnBoardingShowReorderPopup(false));
        setLocalOnBoardingShowReorderPopup(false);
        const MySwal = withReactContent(Swal)
        if (!MySwal.isVisible()) {
            MySwal.fire({
                ...SWAL_DEFAULTS,
                title: "Перемещение слайдов",
                customClass: {
                    container: 'sl-swal sl-swal-reorder-slides-info'
                },
                html: <div>
                    <img
                        src={'https://files5-cdn.slide-life.ru/reorder.svg'}
                        className={'reorderImage'}
                    />
                    <p>
                        <b>Удерживайте</b> и <b>перемещайте</b> слайды,<br /> чтобы <b>поменять их местами</b>.
                    </p>
                </div>,
                confirmButtonText: 'Понятно',
                showConfirmButton: true,
                showCloseButton: true,
            })
        }
    }, [makerData.slides, makerData.onBoardingShowReorderPopup])

    const onAddSlideClick = () => {
        const MySwal = withReactContent(Swal)

        MySwal.fire({
            ...SWAL_DEFAULTS,
            customClass: {
                container: 'sl-swal sl-swal-add-slide'
            },
            title: "Добавление слайдов",
            html: <Provider store={store}>
                <AddSlidePopup onUpload={onUpload} onAddText={onAddText}></AddSlidePopup>
            </Provider>
            ,
            width: 'auto',
            didOpen: () => {
                dispatch(setIsAddSlidePopupOpen(true));
            },
            willClose: () => {
                dispatch(setIsAddSlidePopupOpen(false));
            }
        })
    }

    const onUpload = (imageList: ImageListType) => {
        imageList.map(async (image: ImageType) => {
            if (!image.file || image.error) {
                // Sentry.captureException(
                //     new Error('Failed to upload one photo. Error.'),
                //     {
                //         extra: {
                //             error: image.error,
                //             name: image.name
                //         }
                //     }
                // )
            } else {
                mutationUploadPhoto.mutateAsync({
                    image: image,
                    dispatch: dispatch,
                    tmpProjectId: tmpProjectId,
                    pid: uuidv4(),
                    makerData: makerData
                }).catch(e => {});
            }
        })
    }

    const onAddText = (text: string) => {
        mutationAddText.mutateAsync({
            text: text,
            dispatch: dispatch,
            tmpProjectId: tmpProjectId,
            pid: uuidv4(),
            makerData: makerData
        }).catch(e => {})
    }

    const onAddTextWithSlideData = (text: string, slideData: SlideData) => {
        mutationAddText.mutateAsync({
            text: text,
            dispatch: dispatch,
            tmpProjectId: tmpProjectId,
            pid: slideData.pid,
            makerData: makerData
        }).catch(e => {})
    }

    const onSlideClick = (slide: SlideData) => {
        dispatch(
            setCurrentSlide(slide)
        )
    }

    const onRotateSlide = async (e: React.MouseEvent<HTMLElement>, slideData: SlideData) => {
        e.stopPropagation();
        mutationRotatePhoto.mutateAsync({
            slideData: slideData,
            dispatch: dispatch,
            makerData: makerData
        }).catch(e => {})
    }

    const onEditSlide = (e: React.MouseEvent<HTMLElement>, slideData: SlideData) => {
        e.stopPropagation();

        const MySwal = withReactContent(Swal)

        MySwal.fire({
            ...SWAL_DEFAULTS,
            customClass: {
                container: 'sl-swal sl-swal-add-slide'
            },
            title: "Редактирование текстового слайда",
            html: <Provider store={store}>
                <EditSlidePopup onAddTextWithSlideData={onAddTextWithSlideData} slideData={slideData}></EditSlidePopup>
            </Provider>
            ,
            width: 'auto'
        })
    }

    const onDeleteSlide = (e: React.MouseEvent<HTMLElement>, slideData: SlideData) => {
        e.stopPropagation();
        dispatch(removeSlide(slideData));
    }

    const onDeleteAllSlides = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();

        Swal.fire({
            title: 'Удалить все слайды?',
            showDenyButton: true,
            confirmButtonText: 'Да, удалить',
            denyButtonText: 'Отмена',
            showCloseButton: true
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                dispatch(removeAllSlides());
            }
        });
    }

    const onDragChoose = () => {
        if (!window) {
            return;
        }

        if (!window.navigator) {
            return;
        }

        if (!window.navigator.vibrate) {
            return;
        }

        window.navigator.vibrate(100);
    }

    return (
        <div className="slides-container">
            <ReactSortable
                list={slides}
                setList={(slides) => dispatch(setSlides(slides))}
                className={'slides-grid'}
                delayOnTouchOnly={true}
                delay={150}
                chosenClass={'chosen'}
                animation={250}
                draggable={'.grid-item-slide'}
                scroll={true}
                onChoose={onDragChoose}
            >
                {
                    slides.map(
                        (slide, index) =>
                            <ErrorBoundary
                                place={'Slide-SlideListItem'}
                                key={'slide-list-item-error-boundary-' + slide.pid}>
                                <SlidesListItem
                                    key={'slide-list-item-' + slide.pid}
                                    data={slide}
                                    onClickAction={onSlideClick}
                                    index={index}
                                    onAddSlideClick={onAddSlideClick}
                                    onRotateSlide={onRotateSlide}
                                    onEditSlide={onEditSlide}
                                    onDeleteSlide={onDeleteSlide}
                                    onDeleteAllSlides={onDeleteAllSlides}
                                />
                            </ErrorBoundary>
                    )
                }
            </ReactSortable>
        </div>
    );
})

export default SlidesList;